<template>
  <div class="rzy-page">
    <div class="rzy-top-bar">
      <el-button
        type="primary"
        @click="initPrint()"
        size="mini"
        icon="el-icon-printer"
        >打印</el-button
      >
    </div>
    <div id="needPrint" class="hello">
      <div
        style="width:794px; height: 1123px; margin:auto; border: 4px solid #000; "
      >
        <!-- 标题栏 -->
        <div
          class="title-3"
          style="width:100%;height:70px; border: 1px solid #000;display: flex"
        >
          <div class="bianhao" style="width: 35%;">
            <p class="biaohao-1">{{ bianhao }}</p>
          </div>
          <div
            class="gongdan"
            style="width: 30%;font-size: 42px;font-weight: 2000;text-align: center; line-height: 90px;"
          >
            生产工单
          </div>
          <div class="riqi" style="width: 35%;">
            <p>{{ riqi }}</p>
          </div>
        </div>

        <!-- 主要信息 -->
        <div
          class="mainbox"
          style="height:251px; width:100%;border: 1px solid #000;"
        >
          <div
            style="width: 100%;height:50px; display: flex; border-bottom:1px solid #000 ;"
          >
            <div class="mainbox-item" style="width: 12%;">胚布名称</div>
            <div class="mainbox-value" style="width: 37%;">
              {{ productName }}
            </div>
            <div class="mainbox-item" style="width: 12%;">机台</div>
            <div class="mainbox-value" style="width: 36.8%;">
              {{ machineNumber }}
            </div>
            <!-- <div class="mainbox-item" style="width: 12%;">机台型号</div>
            <div class="mainbox-value" style="width: 25%;border-right: 0;">
              {{ machineType }}
            </div> -->
          </div>
          <div
            style="width: 100%;height:50px; display: flex; border-bottom:1px solid #000 ;"
          >
            <div class="mainbox-item" style="width: 12%;">车速</div>
            <div class="mainbox-value" style="width: 37%;">{{ speed }}</div>
            <div class="mainbox-item" style="width: 12%;">机台型号</div>
            <div class="mainbox-value" style="width: 37%;border-right: 0;">
              {{ machineType }}
            </div>
          </div>

          <div
            style="width: 100%;height:50px; display: flex;border-bottom:1px solid #000 ;"
          >
            <div class="mainbox-item" style="width: 12%;">上机密度</div>
            <div class="mainbox-value" style="width: 37%;">{{ density }}</div>
            <div class="mainbox-item" style="width: 12%;">胚布克重</div>
            <div class="mainbox-value" style="width: 37%;border-right: 0;">
              {{ squareGrams }}
            </div>
          </div>
          <div
            style="width: 100%;height:50px; display: flex;border-bottom:1px solid #000 ;"
          >
            <div class="mainbox-item" style="width: 13.7%;">计划重量</div>
            <div class="mainbox-value" style="width: 32%;">
              {{ predictWeight }}
            </div>
            <div class="mainbox-item" style="width: 12%;">幅数</div>
            <div class="mainbox-value" style="width: 15%;">
              {{ combsCount }}
            </div>
            <div class="mainbox-item" style="width: 12%;">布长</div>
            <div class="mainbox-value" style="width: 25%; border-right: 0;">
              {{ dropClothLength }}
            </div>
          </div>

          <div style="width: 100%;height:50px; display: flex;">
            <div class="mainbox-item" style="width: 13.43%;">计划米数</div>
            <div class="mainbox-value" style="width: 31%;">
              {{ predictProducedLength }}
            </div>
            <div class="mainbox-item" style="width: 11.8%;">幅宽</div>
            <div class="mainbox-value" style="width: 53.3%;border-right: 0;">
              {{ combs }}
            </div>
          </div>
        </div>

        <div
          style="width: 100%; height: 20px;border: 1px solid #000;margin:auto;"
        ></div>
        <!-- 原料 -->
        <div class="yuanliao" sytle="width:100%;  border: 1px solid #000;">
          <div
            class="yuanliao-1"
            style="width: 100%;height:50px; border: 1px solid #000;display: flex;"
          >
            <div class="yuanliao-item" style="width:  10%;font-weight: 800">
              原料
            </div>
            <div class="yuanliao-value" style="width: 15%;font-weight: 800">
              头纹
            </div>
            <div class="yuanliao-value" style="width: 15%;font-weight: 800">
              盘头数
            </div>
            <div class="yuanliao-value" style="width: 15%;font-weight: 800">
              送经量
            </div>
            <div
              class="yuanliao-value"
              style="width: 45%;font-weight: 800;border-right: 0; "
            >
              规格
            </div>
          </div>
          <div
            class="yuanliao-1"
            style="width: 100%;height:50px; border: 1px solid #000;display: flex;"
          >
            <div class="yuanliao-item" style="width:  10%;">GB1</div>
            <div class="yuanliao-value" style="width: 15%;">
              {{ GB1_touwen }}
            </div>
            <div class="yuanliao-value" style="width: 15%;">
              {{ GB1_panHeadNum }}
            </div>
            <div class="yuanliao-value" style="width: 15%;">
              {{ GB1_songshaliang }}
            </div>
            <div class="yuanliao-value" style="width: 45%;border-right: 0; ">
              {{ GB1_guige }}
            </div>
          </div>
          <div
            class="yuanliao-1"
            style="width: 100%;height:50px; border: 1px solid #000;display: flex;"
          >
            <div class="yuanliao-item" style="width: 10%;">GB2</div>
            <div class="yuanliao-value" style="width: 15%;">
              {{ GB2_touwen }}
            </div>
            <div class="yuanliao-value" style="width: 15%;">
              {{ GB2_panHeadNum }}
            </div>
            <div class="yuanliao-value" style="width: 15%;">
              {{ GB2_songshaliang }}
            </div>
            <div class="yuanliao-value" style="width: 45%;border-right: 0; ">
              {{ GB2_guige }}
            </div>
          </div>
          <div
            class="yuanliao-1"
            style="width: 100%;height:50px; border: 1px solid #000;display: flex;"
          >
            <div class="yuanliao-item" style="width: 10%;">GB3</div>
            <div class="yuanliao-value" style="width: 15%;">
              {{ GB3_touwen }}
            </div>
            <div class="yuanliao-value" style="width: 15%;">
              {{ GB3_panHeadNum }}
            </div>
            <div class="yuanliao-value" style="width: 15%;">
              {{ GB3_songshaliang }}
            </div>
            <div class="yuanliao-value" style="width: 45%; border-right: 0;">
              {{ GB3_guige }}
            </div>
          </div>
          <div
            class="yuanliao-1"
            style="width: 100%;height:50px; border: 1px solid #000;display: flex;"
          >
            <div class="yuanliao-item" style="width: 10%; ">GB4</div>
            <div class="yuanliao-value" style="width: 15%; ">
              {{ GB4_touwen }}
            </div>
            <div class="yuanliao-value" style="width: 15%;">
              {{ GB4_panHeadNum }}
            </div>
            <div class="yuanliao-value" style="width: 15%; ">
              {{ GB4_songshaliang }}
            </div>
            <div class="yuanliao-value" style="width: 45%; border-right: 0;">
              {{ GB4_guige }}
            </div>
          </div>
        </div>

        <div
          style="width: 100%; height: 20px;border: 1px solid #000;margin:auto;line-height: 60px; text-align: center;"
        ></div>

        <!-- 穿纱方式 -->
        <div
          style="width: 100%; height: 300px;border: 1px solid #000;margin:auto;"
        >
          <div
            style="height:20%; width: 100%; display: flex;border-bottom: 1px solid #000;"
          >
            <div
              class="yuanliao-item"
              style="width: 9.8%; border-right: 1px solid #000;text-align: center;"
            ></div>
            <div
              style="width: 51.3%; border-right: 1px solid #000;text-align: center;line-height: 50px;font-weight: 800;"
            >
              工艺组织
            </div>
            <div
              style="width: 38%; text-align: center; line-height: 50px;font-weight: 800;"
            >
              穿纱方式
            </div>
          </div>

          <div
            style="height:20%; width: 100%; display: flex;border-bottom: 1px solid #000;"
          >
            <div
              class="yuanliao-item"
              style="width: 10%;line-height: 50px;  border-right: 1px solid #000;"
            >
              GB1
            </div>
            <div
              class="yuanliao-value"
              style="width: 52%; word-break:break-all ;border-right: 1px solid #000;text-align: center;"
            >
              {{ GB1_organization }}
            </div>
            <div
              class="yuanliao-value"
              style="width: 38%; word-break:break-all ;text-align: center;"
            >
              {{ GB1_crossYarnWay }}
            </div>
          </div>
          <div
            style="height:20%; width: 100%; display: flex;border-bottom: 1px solid #000;"
          >
            <div
              class="yuanliao-item"
              style="width: 10%;line-height: 50px;  border-right: 1px solid #000;"
            >
              GB2
            </div>
            <div
              class="yuanliao-value"
              style="width: 52%; word-break:break-all ;border-right: 1px solid #000;text-align: center;"
            >
              {{ GB2_organization }}
            </div>
            <div
              class="yuanliao-value"
              style="width: 38%; word-break:break-all ;text-align: center;"
            >
              {{ GB2_crossYarnWay }}
            </div>
          </div>
          <div
            style="height:20%; width: 100%; display: flex;border-bottom: 1px solid #000;"
          >
            <div
              class="yuanliao-item"
              style="width: 10%;line-height: 50px;border-right: 1px solid #000;"
            >
              GB3
            </div>
            <div
              class="yuanliao-value"
              style="width: 52%; word-break:break-all ;border-right: 1px solid #000;text-align: center;"
            >
              {{ GB3_organization }}
            </div>
            <div
              class="yuanliao-value"
              style="width: 38%; word-break:break-all ;text-align: center;"
            >
              {{ GB3_crossYarnWay }}
            </div>
          </div>
          <div style="height:20%; width: 100%; display: flex;">
            <div
              class="yuanliao-item"
              style="width: 10%;line-height: 50px; border-right: 1px solid #000;"
            >
              GB4
            </div>
            <div
              class="yuanliao-value"
              style="width: 52%; word-break:break-all ;border-right: 1px solid #000;text-align: center;"
            >
              {{ GB4_organization }}
            </div>
            <div
              class="yuanliao-value"
              style="width: 38%; word-break:break-all ;text-align: center;"
            >
              {{ GB4_crossYarnWay }}
            </div>
          </div>
        </div>

        <!-- 备注 -->
        <div
          style="width: 100%; height: 150px;border: 1px solid #000;margin:auto;"
        >
          <div style="width: 100%; height: 100%;  display: flex;margin:auto;">
            <div
              style="width: 9.8%;padding-left: 5px;font-weight: 800; height: 100%; border-right: 1px solid #000; display: flex; align-items: center;text-align: center;"
            >
              备<br /><br /><br /><br />注
            </div>
            <div
              style="width: 90%; display: flex; align-items: center;  word-break:break-all;font-size:20px;"
            >
              {{ remark }}
            </div>
          </div>
        </div>

        <!-- 制单人 -->
        <div
          style="width: 100%; height:50px;margin:auto;border-top: 1px solid #000;"
        >
          <div style="width: 100%;  display: flex;">
            <div
              style="width: 50%; text-align: left;margin-left: 5px;line-height: 50px;font-weight: 800;"
            >
              {{ zhiDanRen }}
            </div>
            <div
              style="width: 50%; text-align: left;margin-left: 5px;line-height: 50px;font-weight: 800;"
            >
              {{ shengHeRen }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "workOrderPrint",
  props: {
    productName: String,
    bianhao: String,
    riqi: String,

    machineNumber: String,
    productPlan: String,
    speed: String,
    density: String,
    squareGrams: String,
    combs: String,
    combsCount: String,
    dropClothLength: String,
    predictProducedLength: String,
    meterWeight: String,
    machineType: String,
    predictWeight: String,

    GB1_touwen: String,
    GB2_touwen: String,
    GB3_touwen: String,
    GB4_touwen: String,

    GB1_pantou: String,
    GB2_pantou: String,
    GB3_pantou: String,
    GB4_pantou: String,

    GB1_songshaliang: String,
    GB2_songshaliang: String,
    GB3_songshaliang: String,
    GB4_songshaliang: String,

    GB1_hanshaliang: String,
    GB2_hanshaliang: String,
    GB3_hanshaliang: String,
    GB4_hanshaliang: String,

    GB1_guige: String,
    GB2_guige: String,
    GB3_guige: String,
    GB4_guige: String,

    GB1_chuanshafangshi: String,
    GB2_chuanshafangshi: String,
    GB3_chuanshafangshi: String,
    GB4_chuanshafangshi: String,

    GB1_panHeadNum: String,
    GB2_panHeadNum: String,
    GB3_panHeadNum: String,
    GB4_panHeadNum: String,

    GB1_organization: String,
    GB2_organization: String,
    GB3_organization: String,
    GB4_organization: String,

    GB1_crossYarnWay: String,
    GB2_crossYarnWay: String,
    GB3_crossYarnWay: String,
    GB4_crossYarnWay: String,

    remark: String,
    zhiDanRen: String,
    shengHeRen: String,
  },
  data() {
    console.log("打印工单");
    return {
      title: "打印工单",
    };
  },
  created() {
    var workOrderInfo = this.$route.query.data;
    this.initdata(workOrderInfo);
    console.log(workOrderInfo);
  },
  mounted() {
    this.initPrint();
    this.autoClose();
  },

  methods: {
    autoClose: function() {
      var currentView = this.$store.state.tagsView.visitedViews[0];
      for (currentView of this.$store.state.tagsView.visitedViews) {
        if (currentView.path === this.$route.path) {
          break;
        }
      }
      this.$store
        .dispatch("tagsView/delView", currentView)
        .then(({ visitedViews }) => {
          if (currentView.path === this.$route.path) {
            const latestView = this.$store.state.tagsView.visitedViews.slice(
              -1
            )[0];
            if (latestView) {
              this.$router.push(latestView);
            } else {
              // 如果没有其他标签则跳转到首页
              if (currentView.name === "首页") {
                this.$router.replace({
                  path: "/redirect" + currentView.fullPath,
                });
              } else {
                this.$router.push("/");
              }
            }
          }
        });
    },
    initdata: function(info) {
      try {
        console.log(this.$route.query.data);
        const workOrder = this.$route.query.data;
        if (workOrder == null) return;

        this.productName = workOrder.craftsheet.name;
        this.bianhao = "编号：" + workOrder.number;
        this.riqi = workOrder.createTime;

        this.machineNumber = workOrder.machineNumber;
        this.machineType = workOrder.machineType;
        this.speed = workOrder.speed + " 转/分钟";
        console.log(this.speed);
        this.density = workOrder.density;
        this.squareGrams = workOrder.squareGrams + " g/m2";
        this.combsCount = workOrder.combsCount + " 幅";
        this.combs = workOrder.combs + " (cm)";
        this.dropClothLength =
          parseInt(workOrder.dropClothLength) / 100 + " 米";

        this.predictProducedLength =
          parseInt(workOrder.predictProducedLength) / 100 + " 米";
        this.meterWeight = workOrder.meterWeight + " Kg";
        this.predictWeight = workOrder.predictWeight + " Kg";

        var abb = workOrder.craftsheet.craftItems;
        for (let i = 0; i < abb.length; i++) {
          var cmd =
            "this." +
            abb[i].combSection +
            "_songshaliang=" +
            "'" +
            abb[i].sendYarnFeed +
            "'";
          eval(cmd);

          cmd =
            "this." +
            abb[i].combSection +
            "_panHeadNum=" +
            "'" +
            abb[i].panHeadNum +
            "'";
          eval(cmd);

          cmd =
            "this." +
            abb[i].combSection +
            "_touwen=" +
            "'" +
            abb[i].headVeins +
            "'";
          eval(cmd);

          cmd =
            "this." +
            abb[i].combSection +
            "_guige=" +
            "'" +
            abb[i].materialStandard +
            "'";
          eval(cmd);

          cmd =
            "this." +
            abb[i].combSection +
            "_crossYarnWay=" +
            "'" +
            abb[i].crossYarnWay +
            "'";
          eval(cmd);

          cmd =
            "this." +
            abb[i].combSection +
            "_organization=" +
            "'" +
            abb[i].organization +
            "'";
          eval(cmd);
        }

        this.remark = workOrder.remark;
        this.zhiDanRen = "制单人：";
        this.shengHeRen = "审核人：";
      } catch (e) {
        console.log(e);
      }
    },

    // 在打印当前报表前，拼接title
    initPrint() {
      let style = `
		* {
			margin: 0;
			padding: 0;
			font-size: 20px;
			font-weight: 500;
			font-family:'Microsoft YaHei';
			/* line-height: 40px; */
			}
			
			.mainbox-item{
				line-height:50px;
				text-align: left;
				padding-left: 5px;
				padding-right: 5px;
				border-right:1px solid #000;	
				font-weight: 700;
				display: inline-block;
				
				text-align: justify;
				text-align-last:justify;
				text-justify: distribute-all-lines;/*这行必加，兼容ie浏览器*/
			}
			.mainbox-value{
				line-height:50px;
				text-align: left;
				padding-left: 5px;
				border-right:1px solid #000;
				font-size: 20px;
				font-weight: 600;
			}	
			.yuanliao-item{
				padding-left: 5px;
				border-right:1px solid #000;
				text-align: left;
				line-height:50px;
				font-weight: 800;
			}
			.yuanliao-value{
				padding-left: 5px;
				border-right:1px solid #000;
				text-align: center;
				line-height:50px;
				font-size: 18px;
				font-weight: 600;
			}
			.riqi{
				height: 100% !important;
				position: relative;
				margin-right: 5px;
			}
			.riqi p{
				position: absolute; 
				bottom: 5px;
				text-align: right;
				width:100%;
			}
			.bianhao{
				height: 100% !important;
				position: relative;
				margin-left: 5px;			
			}
			.bianhao p{
				position: absolute; 
				bottom: 5px;
				width:100%;
			}

		`;
      this.utils.printElement("needPrint", `工单详情`, style);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
* {
  margin: 0;
  padding: 0;
  font-size: 22px;
  font-weight: 700;
  font-family: "Microsoft YaHei";
  /* line-height: 40px; */
}

.mainbox-item {
  line-height: 50px;
  text-align: left;
  padding-left: 5px;
  padding-right: 5px;
  border-right: 1px solid #000;
  font-weight: 800;
  display: inline-block;

  text-align: justify;
  text-align-last: justify;
  text-justify: distribute-all-lines; /*这行必加，兼容ie浏览器*/
}
.mainbox-value {
  line-height: 50px;
  text-align: left;
  padding-left: 5px;
  border-right: 1px solid #000;
  font-size: 18px;
}
.yuanliao-item {
  padding-left: 5px;
  border-right: 1px solid #000;
  text-align: left;
  line-height: 50px;
  font-weight: 800;
}
.yuanliao-value {
  padding-left: 5px;
  border-right: 1px solid #000;
  text-align: center;
  line-height: 50px;
}
.riqi {
  height: 100% !important;
  position: relative;
  margin-right: 5px;
}
.riqi p {
  position: absolute;
  bottom: 5px;
  text-align: right;
  width: 100%;
}
.bianhao {
  height: 100% !important;
  position: relative;
  margin-left: 5px;
}
.bianhao p {
  position: absolute;
  bottom: 5px;
  width: 100%;
}
</style>
